export default "__VITE_ASSET__D6bG_gsk__"